import React, { type FC } from "react";
import { DEFAULT_SUBTITLE_COLOR } from "clientState/AuthFlow/providers/ModalScreenProvider/constants";
import { Body, Flex, Heading } from "@edreamsodigeo/prisma-design-system";

import { type ScreenHeaderProps } from "./contract";

const ScreenHeader: FC<ScreenHeaderProps> = ({
  title,
  subtitle,
  showTitle,
  showSubtitle,
}) => {
  const { color: titleColor, content: titleContent } = title || {};
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="2x_small"
      mt="minus_3x_big"
    >
      {showTitle && (
        <Heading
          type={["2", "1"]}
          weight="medium"
          textAlign="center"
          color={titleColor}
        >
          {titleContent}
        </Heading>
      )}
      {showSubtitle && (
        <Body type="small" color={DEFAULT_SUBTITLE_COLOR} textAlign="center">
          {subtitle}
        </Body>
      )}
    </Flex>
  );
};
export default ScreenHeader;
